import type { AxiosInstance } from 'axios';
import { trackNetworkPromise } from './networkPromiseGroup';

const requestMethods = new Set<PropertyKey>([
  'request',
  'get',
  'delete',
  'head',
  'options',
  'post',
  'put',
  'patch',
  'postForm',
  'putForm',
  'patchForm',
]);

function trackResult(result: unknown): unknown {
  return result instanceof Promise ? trackNetworkPromise<unknown>(result) : result;
}

export function trackNetworkClient(client: AxiosInstance): AxiosInstance {
  const methods = new WeakMap<object, (...args: unknown[]) => unknown>();
  return new Proxy(client, {
    apply: (target, thisArg, args) => trackResult(Reflect.apply(target, thisArg, args)),
    get(target, key, receiver) {
      const value: unknown = Reflect.get(target, key, receiver);
      if (!requestMethods.has(key) || typeof value !== 'function') return value;
      let method = methods.get(value);
      if (!method) {
        method = (...args) => trackResult(Reflect.apply(value, target, args));
        methods.set(value, method);
      }
      return method;
    },
  });
}
